/**
 * @internal
 * **Do not use.** Ask about your use case in #hds-support.
 */

export const isOptionGroup = option => 'options' in option && !!option.options;